export default __webpack_public_path__ + "static/media/bg_banner_bottom-sm.04ec7fa3.jpeg";